import type {
  AutoTradeDrawerParams,
  GamePlayerProjectionScore
} from '@library/types/scoring';
import type { LeagueInfo } from '@library/types/leagues';
import { ScoringRow } from '@library/components/scoring';
import { findProjectionByProjectionId } from '@bo-utils/projection';

export interface ScoringRowsProps {
  changes: Array<Partial<GamePlayerProjectionScore>>;
  initialScoresData: Array<GamePlayerProjectionScore>;
  handleShowHistoryDrawer: (params: AutoTradeDrawerParams) => void;
  leagueInfo?: LeagueInfo;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: Partial<GamePlayerProjectionScore>;
    initialProjection: GamePlayerProjectionScore;
  }) => void;
}

export const ScoringRows = ({
  changes,
  initialScoresData,
  handleShowHistoryDrawer,
  leagueInfo = undefined,
  updateProjection
}: ScoringRowsProps) => {
  if (!leagueInfo) {
    return null;
  }

  const scoringRows: Array<JSX.Element> = initialScoresData?.map(
    (initialProjection) => {
      const change = findProjectionByProjectionId({
        projectionArray: changes,
        projectionId: initialProjection.projectionId
      });

      return (
        <ScoringRow
          change={change}
          handleShowHistoryDrawer={handleShowHistoryDrawer}
          leagueInfo={leagueInfo}
          key={initialProjection.projectionId}
          projection={initialProjection}
          updateProjection={updateProjection}
        />
      );
    }
  );

  return <tbody className="text-2xs xl:text-xs">{scoringRows}</tbody>;
};
